import React , { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import {
  PULSE_DURATION, PLAN_TYPE
} from "../../../utilities/constant";

import { FaPlus  } from 'react-icons/fa';


export default function RenderVoicePlanForm(props) {
  const [error, setError] = useState("");
  const [planNameError, setPlanNameError] = useState("");
  const currentValue = props.userPulseDuration || 1;
  
  // Pass planNameError to parent component
  useEffect(() => {
    if (props.setPlanNameError) {
      props.setPlanNameError(planNameError);
    }
  }, [planNameError, props]);
  const filteredDurations = PULSE_DURATION.filter(item => item.value >= currentValue);
  const [priceError, setPriceError] = useState("");
  const [durationError, setDurationError] = useState("");
  const [pulsePriceError, setpulsePriceError] = useState("");
  const filteredPlan = PLAN_TYPE.filter(item => !props.currentPlan.includes(item.value));

  const handleAddPlan = () => {
    let isValid = true;

    // Check for plan name validation errors
    if (planNameError) {
      isValid = false;
    }

    if (!props.pulsePrice) {
      setPriceError("Pulse Price is required");
      isValid = false;
    } else {
      // Validate decimal places
      const numValue = parseFloat(props.pulsePrice);
      if (isNaN(numValue)) {
        setPriceError("Pulse Price must be a valid number");
        isValid = false;
      } else {
        // Check if more than 2 decimal places
        const decimalParts = props.pulsePrice.toString().split('.');
        if (decimalParts.length > 1 && decimalParts[1].length > 2) {
          setPriceError("Price must have maximum 2 decimal places");
          isValid = false;
        } else {
          setPriceError("");
        }
      }
    }
    if (props.planType !== 'MISSED') {
      if (!props.pulseDuration || props.pulseDuration === "0") {
        setDurationError("Pulse Duration is required");
        isValid = false;
      } else {
        setDurationError("");
      }
    }

    {(priceError || pulsePriceError) && (
      <small className="text-danger">
        {pulsePriceError || priceError}
      </small>
    )}
  
    if (!isValid) return;

    // Convert pulse_price to number and ensure it's valid
    const pulsePriceNum = parseFloat(props.pulsePrice);
    if (isNaN(pulsePriceNum)) {
      setPriceError("Pulse Price must be a valid number");
      return;
    }

    const newPlan = {
      pulse_price: pulsePriceNum, // Convert to number
      pulse_duration: Number(props.pulseDuration), // Convert to number
      plan_type : props.planType
    };
    props.setCurrentPlan((prev) => [...prev, props.planType]);
    props.setPlansData((prevData) => [...prevData, newPlan]);
    props.setPulseDuration("0");
    props.setPulsePrice("");
    props.setPlanType("")
  };

  return (

    
    <>
    
      <div className="row">
        <Form.Group className="col-md-4 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="status">Plan Name <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Control
            type="text"
            id="planName"
            value={props.planName}
            // disabled={props.plansData.length > 0}
            placeholder="Plan Name"
            onChange={(e) => {
              const value = e.target.value;
              // Check for numbers
              if (/[0-9]/.test(value)) {
                setPlanNameError("Numbers are not allowed in plan name");
              } 
              // Check for special characters (allow only letters and spaces)
              else if (/[^a-zA-Z\s]/.test(value)) {
                setPlanNameError("Special characters are not allowed in plan name");
              } 
              else {
                setPlanNameError("");
              }
              props.setPlanName(value);
            }}
          />
          {planNameError && <small className="text-danger">{planNameError}</small>}
        </Form.Group>
        <Form.Group className="col-md-4 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="call_type">Select Call Type: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Select
            id="call_type"
            className="p-2"
            value={props.planType}
            onChange={(e) => {
              props.setPlanType(e.target.value);
              props.setPulsePrice(""); 
              setError("");             
            }}
          >
            <option value="">Select Call Type</option>
            {filteredPlan.map(function (val, idx) {
                return (
                  <option key={idx} value={val.value}>
                    {val.label}
                  </option>
                );
              })}
          </Form.Select>
        </Form.Group>
      </div>
      {props.planType && (
        <div className= "row" style={{ alignItems: "flex-end" }}>  
          {(props.planType !== 'MISSED') && (
            <Form.Group className="col-md-4 form-group">
              {/* {props.isEditMode && ( */}
                <Form.Label htmlFor="status">Select Pulse Duration:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
              {/* )} */}
              <Form.Select
                id="plan_name"
                value={props.pulseDuration}
                className="p-2"
                onChange={(e) => props.setPulseDuration(e.target.value)}
              >
                <option value={0}>Select Pulse Duration</option>
                {PULSE_DURATION.map(function (val, idx) {
                  return (
                    <option key={idx} value={val.value}>
                      {val.label}
                    </option>
                  );
                })}
              </Form.Select>
              {durationError && <small className="text-danger">{durationError}</small>}
            </Form.Group>
          )}
          
          <Form.Group className="col-md-4 form-group">
            {/* {props.isEditMode &&  */}
            <Form.Label htmlFor="status">Pulse Price (paisa)<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            {/* } */}
            <Form.Control
              type="text"
              id="pulsePrice"
              value={props.pulsePrice}
              placeholder="Pulse Price"
              onChange={(e) => {
                let value = e.target.value;
                // Allow only numbers and one decimal point
                if (!/^\d*\.?\d*$/.test(value)) return;
                
                // Limit to 2 decimal places
                const decimalParts = value.split('.');
                if (decimalParts.length > 1 && decimalParts[1].length > 2) {
                  return; // Don't allow more than 2 decimal places
                }
                
                if (parseFloat(value) > 1000) return;
                
                // Validate decimal places on blur/submit
                if (value && value.includes('.')) {
                  const numValue = parseFloat(value);
                  if (!isNaN(numValue)) {
                    const roundedValue = numValue.toFixed(2);
                    if (value !== roundedValue && !value.endsWith('.')) {
                      setpulsePriceError("Price must have maximum 2 decimal places");
                    } else {
                      setpulsePriceError("");
                    }
                  }
                } else {
                  setpulsePriceError("");
                }
                
                props.setPulsePrice(value);
              }}
              onBlur={(e) => {
                let value = e.target.value;
                if (value && value.trim() !== '') {
                  const numValue = parseFloat(value);
                  if (!isNaN(numValue)) {
                    // Round to 2 decimal places
                    const roundedValue = numValue.toFixed(2);
                    props.setPulsePrice(roundedValue);
                    setpulsePriceError("");
                  }
                }
              }}
            />
            {/* {error && <small className="text-danger">{error}</small>} */}
            {priceError && <small className="text-danger">{priceError}</small>}
            {(pulsePriceError || priceError) && (
              <small className="text-danger">
                {pulsePriceError || priceError}
              </small>
            )}
          </Form.Group>
          <Form.Group className="col-md-4 form-group" style={{ display: "flex", alignItems: "flex-end" }}>
            <div
              style={{
                background: planNameError ? "#6c757d" : "#007bff",
                color: "white",
                width: "50px",
                height: "38px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: planNameError ? "not-allowed" : "pointer",
                opacity: planNameError ? 0.6 : 1,
              }}
              onClick={planNameError ? undefined : handleAddPlan}
            >
              <FaPlus fontSize="18px" />
            </div>
          </Form.Group>
            
      </div>
      )}

    </>
  );
}
